import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import myImg from "../../Assets/sobremi.webp";
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";
import Counter from "../Counter";
import SponsorsWall from "./SponsorsWall";

import Ovonic from "../../Assets/Sponsors/ovonic.webp";
import Diatone from "../../Assets/Sponsors/Diatone.webp";
import FolienrabeLogo from "../../Assets/Sponsors/FolienrabeLogo.webp";
import Gemfan from "../../Assets/Sponsors/Gemfan.webp";
import iflight from "../../Assets/Sponsors/iflight.webp";
import Runcam from "../../Assets/Sponsors/Runcam.webp";
import SkyDrone from "../../Assets/Sponsors/SkyDrone.webp";
import Tmotor from "../../Assets/Sponsors/T-Motor.webp";
import Meps from "../../Assets/Sponsors/meps.webp";
import Torvol from "../../Assets/Sponsors/Torvol.webp";

function AboutCard() {
   const { t } = useTranslation();
   const [countersStarted] = useState(true); // siempre activos

   const carouselImages = [
   {src: require("../../Assets/a2rl.webp"), alt: "A2RL Tii Racing World Champions 2026"},
      { src: require("../../Assets/bdr.webp"), alt: "Balearic Drone Racing" },
      {
         src: require("../../Assets/toledo.webp"),
         alt: "Iberian Drone League - Toledo 2020",
      },
      // {
      //    src: require("../../Assets/mdp.webp"),
      //    alt: "Mollerussa Drone Party 2020",
      // },
      {
         src: require("../../Assets/dcl.gif"),
         alt: "Drone Champions League 2020",
      },
   ];

   const sponsors = [
      { name: "Ovonic", image: Ovonic },
      { name: "Diatone", image: Diatone },
      { name: "Folienrabe", image: FolienrabeLogo },
      { name: "Gemfan", image: Gemfan },
      { name: "Runcam", image: Runcam },
      { name: "SkyDrone", image: SkyDrone },
      { name: "T-Hobby", image: Tmotor },
      { name: "MEPS", image: Meps },
      { name: "iFlight", image: iflight },
      { name: "Torvol", image: Torvol },
   ];

   return (
      <Card className="quote-card-view" id="aboutme">
         <Card.Body>
            {/* --- SECCIÓN 1 --- */}
            <div className="about-card-container">
               <div className="about-text-container visible">
                  <blockquote className="blockquote mb-0">
                     <h2 id="about-title">{t("history_title")}</h2>
                     <p className="heading-description">
                        {t("namis")} <span className="purple">{t("name")}</span>
                        {t("wellknown")}
                        <span className="purple">{t("falcon")}</span>
                        {t("history_content")}
                     </p>
                     <p className="heading-description">
                        {t("history_content_2")}
                     </p>
                  </blockquote>
               </div>

               <div className="profile-pic-container">
                  <div className="pic-shadow visible"></div>
                  <img
                     src={myImg}
                     className="profile-pic visible"
                     alt="avatar"
                     loading="lazy"
                  />
               </div>
            </div>

            {/* --- SECCIÓN 2 --- */}
            <div className="about-card-container">
               <div className="history-carousel-container">
                  <div className="history-carousel visible">
                     <Carousel>
                        {carouselImages.map((image, index) => (
                           <Carousel.Item key={index}>
                              <img
                                 className="d-block"
                                 src={image.src}
                                 alt={image.alt}
                                 loading="lazy"
                              />
                              <p>{image.alt}</p>
                           </Carousel.Item>
                        ))}
                     </Carousel>
                  </div>
               </div>

               <div className="about-text-container visible">
                  <blockquote className="blockquote mb-0">
                     <h3 className="heading-title">{t("highlights_title")}</h3>
                     <ul className="heading-description">
                        <li>{t("highlight_6")}</li>
                        <li>{t("highlight_1")}</li>
                        <li>{t("highlight_5")}</li>
                        <li>{t("highlight_2")}</li>
                        <li>{t("highlight_3")}</li>
                        <li>
                           {t("highlight_4")}{" "}
                           <span className="purple">{t("sdt")}</span>
                        </li>
                     </ul>
                     <p className="heading-description">
                        {t("experience_summary")}
                     </p>
                  </blockquote>
               </div>
            </div>

            {/* --- SPONSORS --- */}
            <div className="sponsors-container">
               <h3>{t("sponsors")}</h3>
               <p>{t("sponsors_desc")}</p>
               <SponsorsWall
                  items={sponsors}
                  direction="horizontal"
                  pauseOnHover={false}
               />
            </div>

            {/* --- EXPERIENCIA --- */}
            <div className="about-card-container">
               <div className="experience-container visible">
                  <h3 className="heading-title">{t("experience")}</h3>

                  <div className="experience-counters">
                     <div className="years-container">
                        {countersStarted && (
                           <Counter
                              value={8}
                              places={[1]}
                              fontSize={80}
                              padding={5}
                              gap={10}
                              textColor="var(--imp-background-light-color)"
                              fontWeight={900}
                              duration={2}
                           />
                        )}
                        <p className="years-text">{t("years_flying")}</p>
                     </div>

                     <div className="hours-container">
                        {countersStarted && (
                           <Counter
                              value={2600}
                              places={[1000, 100, 10, 1]}
                              fontSize={80}
                              padding={5}
                              gap={10}
                              textColor="var(--imp-background-light-color)"
                              fontWeight={900}
                              duration={2}
                           />
                        )}
                        <p className="hours-text">{t("flight_hours")}</p>
                     </div>
                  </div>
               </div>
            </div>
         </Card.Body>
      </Card>
   );
}

export default AboutCard;
